import ModalComponent from '../../shared/components/ModalComponent';

export default class DepositBookingComponent extends ModalComponent {
    private form: HTMLFormElement | null = null;

    private submitButton: HTMLButtonElement | null = null;

    private warningMessage: HTMLElement | null = null;

    private processMessage: HTMLElement | null = null;

    private successMessage: HTMLElement | null = null;

    protected onTemplateInstantiation(): void {
        if (!this.modalElement) {
            return;
        }

        this.form = this.modalElement.querySelector('form');
        this.submitButton = this.modalElement.querySelector('button[type="submit"]');

        if (!this.form || !this.submitButton) {
            return;
        }

        this.warningMessage = this.modalElement.querySelector('#deposit-warning-message');
        this.processMessage = this.modalElement.querySelector('#deposit-process-message');
        this.successMessage = this.modalElement.querySelector('#deposit-success-message');

        this.form?.addEventListener('js-submit', () => {
            if (!this.submitButton) {
                return;
            }

            this.submitButton.disabled = true;
            this.processMessage?.classList.remove('hidden');
        });
    }

    protected onSuccess(): void {
        super.onSuccess();
        this.submitButton?.classList.add('hidden');
        this.form?.classList.add('hidden');
        this.successMessage?.classList.remove('hidden');
        this.warningMessage?.classList.add('hidden');
        this.processMessage?.classList.add('hidden');
    }

    protected onFailure(): void {
        super.onFailure();
        if (!this.submitButton) {
            return;
        }

        this.submitButton.disabled = false;
    }

    static getClassName(): string {
        return 'DepositBookingComponent';
    }
}
